import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're in the pack — use code WELCOME10 for 10% off at checkout.");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" data-testid="newsletter-section" className="bg-fog py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden border border-zinc-900 bg-ink px-6 py-12 sm:px-12 sm:py-16"
        >
          <div className="absolute left-0 top-0 h-1 w-full bg-tiger" />
          <div className="relative mx-auto max-w-2xl text-center">
            <p className="mb-3 flex items-center justify-center gap-3 font-body text-xs font-medium uppercase tracking-[0.3em] text-tiger">
              <span className="h-px w-8 bg-tiger" />Join The Pack<span className="h-px w-8 bg-tiger" />
            </p>
            <h2 className="font-heading text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl lg:text-4xl">
              Get 10% Off Your First Drop
            </h2>
            <p className="mt-4 font-body text-sm text-zinc-400">
              Early access to new drops, limited prints and pack-only discounts. No spam — just fierce gear.
            </p>
            <form onSubmit={handleSubmit} data-testid="newsletter-form" className="mt-8 flex flex-col gap-3 sm:flex-row">
              <div className="relative flex-1">
                <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.co.uk"
                  data-testid="newsletter-email-input"
                  className="w-full border border-zinc-700 bg-smoke py-4 pl-11 pr-4 font-body text-sm text-white placeholder-zinc-500 outline-none transition-colors focus:border-tiger"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit-btn"
                className="bg-tiger px-8 py-4 font-heading text-sm font-bold uppercase tracking-widest text-black transition-colors hover:bg-tiger-hover disabled:opacity-60"
              >
                {loading ? "Joining..." : "Claim 10% Off"}
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
